import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import Footer from "../../../common/Footer";
import "./Faq.css";

const faqs = [
  {
    category: "About CNT Academy",
    questions: [
      {
        q: "What is CNT Academy?",
        a: "A financial education platform specializing in stock market training, including technical and fundamental analysis.",
      },
      {
        q: "Who can enroll?",
        a: "Open to beginners, intermediate traders, and professionals seeking to enhance their market knowledge.",
      },
      {
        q: "Are courses available online or offline?",
        a: "Offers both online self-paced and offline classroom training options.",
      },
      {
        q: "How do I enroll?",
        a: "Visit the website, select a course, and complete the registration process.",
      },
    ],
  },
  {
    category: "Course & Curriculum",
    questions: [
      {
        q: "What topics are covered?",
        a: `• Technical Analysis (Charts, Indicators, Price Action)\n• Fundamental Analysis (Financial Statements, Valuations)\n• Derivatives & Options Trading\n• Risk Management & Trading Psychology\n• Live Market Training Sessions\n• And much more`,
      },
      {
        q: "Are the courses beginner-friendly?",
        a: "Yes, structured from basic to advanced levels for easy understanding.",
      },
      {
        q: "Do you provide live market training?",
        a: "No, as per SEBI Norms training will be on 3 Months Back Data.",
      },
      {
        q: "Will I receive a certification?",
        a: "Yes, a certificate of completion is awarded post-course.",
      },
    ],
  },
  {
    category: "Fees & Payment",
    questions: [
      {
        q: "What are the course fees?",
        a: "Varies based on the program. Details are available on the website.",
      },
      {
        q: "Accepted payment methods?",
        a: "UPI, credit/debit cards, net banking, wallets, and EMI options.",
      },
      {
        q: "Refund policy?",
        a: "Subject to the terms & conditions mentioned on the website.",
      },
    ],
  },
  {
    category: "Learning Support & Access",
    questions: [
      {
        q: "Do you provide mentorship?",
        a: "Yes, one-on-one mentorship is available for select programs.",
      },
      {
        q: "How long do I have access to the course?",
        a: "Lifetime access to recorded sessions and study materials.",
      },
      {
        q: "Is there a support team for queries?",
        a: "Yes, via email, community forums, and WhatsApp groups.",
      },
    ],
  },
  {
    category: "Trading & Market Queries",
    questions: [
      {
        q: "Does CNT Academy provide stock recommendations?",
        a: "No, we focus purely on educational training.",
      },
      {
        q: "Will I be able to trade professionally after completing a course?",
        a: "The training equips you with skills, but success depends on practice & market discipline.",
      },
      {
        q: "Is trading risky?",
        a: "Yes, but we emphasize risk management strategies to mitigate losses.",
      },
    ],
  },
  {
    category: "Contact & Support",
    questions: [
      {
        q: "How to reach CNT Academy?",
        a: "📧 Email: info@cntacademy.com\n📞 Phone: 7384708366\n🌍 Website: www.cntacademy.com",
      },
      {
        q: "Where can I follow CNT Academy?",
        a: "📌 YouTube, Instagram, Twitter, LinkedIn for educational content & market updates.",
      },
    ],
  },
];

const AccordionItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <motion.div layout className="help-faq-item">
      <motion.button
        layout
        onClick={() => setOpen(!open)}
        className="help-faq-question"
      >
        <span className="help-faq-question-text">
          {question}
        </span>
        <FaChevronDown
          className={`help-faq-chevron ${
            open ? "rotate-180" : ""
          }`}
        />
      </motion.button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <div className="help-faq-answer">
              {answer}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const FaqPage = () => {
  return (
    <>
    <main className="help-center-page">
      <div className="help-center-shell">
        <p className="help-center-eyebrow">SUPPORT</p>
        <h1 className="help-center-title">
          Frequently Asked Questions
        </h1>

        {faqs.map((section, index) => (
          <section key={index} className="help-faq-section">
            <h2 className="help-faq-section-title">
              {section.category}
            </h2>
            <div className="help-faq-list">
              {section.questions.map((item, i) => (
                <AccordionItem key={i} question={item.q} answer={item.a} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
    <Footer />
    </>
  );
};

export default FaqPage;
